<template>
    <div class="settings" v-animate-css="{ classes: 'fadeInDown', delay: 0, duration: 300 }">
        <div style="display: flex; flex-direction: row; justify-content: end">
            <a-icon style="font-size: 23px" type="close" v-if="bar !== 0" @click="$emit('close-menu', 0)" />
        </div>
        <a-card style="width: 300px; border: unset">
            <div class="m-3 setting-options" @click="openModal(2)">
                <span class="mr-2 pr-1"> <span class="material-icons"> open_with </span> </span>
                <p class="mt-1 mb-2">{{ $t("chatbotv2.navigation") }}</p>
            </div>
            <div class="m-3 setting-options" @click="openModal(3)">
                <span class="mr-2 pr-1"> <a-icon style="font-size: 24px" type="setting" /> </span>
                <p class="mt-1 mb-2">{{ $t("chatbotv2.botSetting") }}</p>
            </div>
            <div class="m-3 setting-options" @click="exportDiagramToClipboard">
                <span class="mr-2 pr-1"> <a-icon style="font-size: 24px" type="export" /> </span>
                <p class="mt-1 mb-2">{{ $t("chatbotv2.exportDiagramToClipboard") }}</p>
            </div>
        </a-card>
        <template>
            <div id="tool-bar-setting-modal">
                <a-modal
                    title="Settings"
                    wrapClassName="vertical-center-modal"
                    :overlayClassName="'vertical-center-modal'"
                    id="setting-modal"
                    v-model="modalVisible"
                    :afterClose="
                        () => {
                            $emit('close-menu', 0);
                        }
                    "
                    :footer="null"
                    :width="'650px'"
                >
                    <div class="row">
                        <div class="col-xs mx-5">
                            <div
                                @click="openModal(2)"
                                class="row chatbot-tool-bar-setting-options"
                                :style="selection === 2 ? { fontWeight: '600', color: '#006cff' } : { color: 'unset' }"
                            >
                                {{ $t("chatbotv2.navigation") }}
                            </div>
                            <div
                                @click="openModal(3)"
                                class="row chatbot-tool-bar-setting-options"
                                :style="selection === 3 ? { fontWeight: '600', color: '#006cff' } : { color: 'unset' }"
                            >
                                {{ $t("chatbotv2.botSetting") }}
                            </div>
                        </div>
                        <div class="col-lg col-sm">
                            <div v-if="selection === 2" class="navigation">
                                <div class="title">{{$t("chatbotv2.navigation")}}</div>
                                <div class="toolbar-description">
                                    {{ $t("chatbotv2.navigationDesc") }}
                                </div>
                                <div class="d-flex justify-content-center text-center align-items-center pt-3">
                                    <a-button
                                        :type="!navigation ? 'primary' : ''"
                                        size="large"
                                        class="m-3 p-2"
                                        @click="navigation = false"
                                    >
                                        <a-icon type="laptop" />
                                        <span>{{ $t("chatbotv2.trackpad") }}</span>
                                    </a-button>
                                    <a-button
                                        :type="navigation ? 'primary' : ''"
                                        size="large"
                                        class="m-3 p-2"
                                        @click="navigation = true"
                                    >
                                        <md-icon :style="navigation ? { color: 'white' } : { color: '' }"
                                            >mouse
                                        </md-icon>
                                        <span>{{ $t("chatbotv2.mouse") }}</span>
                                    </a-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </a-modal>
            </div>
        </template>
    </div>
</template>

<script>
import { log2 } from "../../../../../../utils/log2";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { copyText2Clipboard } from "../../../../../../utils/utils";
import MessengerIcon from "../../../../Chatbot/pages/integrations/svg/MessengerIcon.vue";
import InstagramIcon from "../../../../Chatbot/pages/integrations/svg/InstagramIcon.vue";
import TelegramIcon from "../../../../Chatbot/pages/integrations/svg/TelegramIcon.vue";
import WhatsappIcon from "../../../../Chatbot/pages/integrations/svg/WhatsappIcon.vue";

const log = log2("SettingsWidget");
export default {
    name: "SettingsWidget",
    props: ["bar", "automation"],
    components: {
        TelegramIcon,
        WhatsappIcon,
        InstagramIcon,
        MessengerIcon,
    },
    computed: {
        ...mapGetters({
            settings: "CB/settings",
        }),
        navigation: {
            get() {
                return "mouse" === "mouse";
            },
            set(value) {
                log("navigation", value);
                const mode = value ? "mouse" : "trackpad";
                //todo refactor
            },
        },
    },
    data() {
        return {
            modalVisible: false,
            selection: 0,
        };
    },
    methods: {
        ...mapActions({
            updateSettings: "CB/updateSettings",
        }),
        ...mapMutations({
            UPDATE_SETTINGS: "CB/UPDATE_SETTINGS",
        }),
        openModal(i) {
            if (this.selection !== i) this.selection = i;
            this.modalVisible = true;
        },
        exportDiagramToClipboard() {
            const jsonBoard = JSON.stringify(this.automation.diagram);
            copyText2Clipboard(jsonBoard);
            this.modalVisible = false;
            this.$message.success("Automation exported  to clipboard");
        },
    },
    mounted() {
        log("mounted", this.$route.params.id);
    },
    watch: {
        settings: {
            handler(newSettings) {
                this.$nextTick(() => {
                    this.$forceUpdate();
                });
            },
            deep: true,
        },
    },
};
</script>

<style lang="scss">
.settings {
    .ant-card-body {
        padding: 0;
    }
}

#tool-bar-setting-modal {
    .vertical-center-modal {
        text-align: center;
        white-space: nowrap;
    }

    .vertical-center-modal:before {
        content: "";
        display: inline-block;
        height: 100%;
        vertical-align: middle;
        width: 0;
    }

    .vertical-center-modal .ant-modal {
        display: inline-block;
        vertical-align: middle;
        top: 0;
        text-align: left;
    }
}

.chatbot-tool-bar-setting-options {
    &:hover {
        color: #06a9f3;
        cursor: pointer;
    }
}

#setting-modal {
    .title {
        margin-bottom: 10px;
        color: #22272d;
        font-weight: 600;
        font-size: 18px;
        line-height: 23px;

        .icon-settings {
            display: flex;
            align-items: start;
            justify-content: center;
            gap: 2px;

            .telegram-icon {
                width: 30px;
                margin-top: -8px;
            }

            .whatsapp-icon {
                width: 30px;
                background: #58ca64;
                border-radius: 120px;
            }

            .messenger-icon {
                width: 30px;
                height: 30px;
            }

            .instagram-icon {
                width: 30px;
                height: 30px;
            }
        }
    }

    .ant-modal-header {
        height: 70px;
        padding: 0 26px 0 40px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }

    .ant-modal-title {
        font-weight: 600;
        font-size: 24px;
        line-height: 31px;
    }

    .ant-modal-close-x {
        width: 100px;
        color: #516173;
        cursor: pointer;
        font-size: 20px;
        margin-left: auto;
        font-weight: 400;
        letter-spacing: 0;
    }

    .chatbot-tool-bar-setting-options {
        cursor: pointer;
        font-size: 18px;
        line-height: 23px;
        margin-bottom: 27px;
    }
}
</style>
<style lang="scss" scoped>
.settings {
    box-shadow: 0px 4px 20px #00000040;
    background: #ffffff;
    padding: 12px;
    border-radius: 6px;
    max-height: 75vh;
    max-width: 400px;
    overflow: auto;

    .navigation {
        display: flex;
        align-items: center;
        gap: 1rem;
    }

    .setting-options {
        display: flex;
        align-items: center;

        &:hover {
            color: #06a9f3;
            cursor: pointer;
        }
    }
}

.toolbar-description {
    overflow-wrap: break-word !important;
    word-break: break-word !important;
    white-space: normal !important;
    color: #516173;
    font-size: 16px;
    line-height: 20px;
}
</style>
